import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { makeStyles, lighten } from '@material-ui/core/styles';
import { IconButton } from '@material-ui/core';
import cn from 'classnames';
import DeleteFbIcon from '../Icons/DeleteFbIcon';
import { TP } from '../../constants/consts';
import AddAnotherFieldButton from './AddAnotherFieldButton';
import { colors } from '../../constants/styleConstants';

const useStyles = makeStyles(theme => ({
  container: {
    display: 'flex',
    alignItems: 'flex-end',
    '&:not(:first-child)': {
      marginTop: theme.spacing(),
    },
  },
  deleteButton: {
    width: 48,
    margin: '0 6px -2px',
    '&:focus': {
      backgroundColor: lighten(colors.red, 0.9),
    },
  },
  addButton: {
    opacity: 0,
    marginBottom: 10,
    minWidth: 48,
    whiteSpace: 'nowrap',
    flexShrink: 0,
    [theme.breakpoints.up('md')]: {
      width: 110,
    },
    [theme.breakpoints.down('sm')]: {
      width: 48,
    },
  },
  input: {
    flexGrow: 1,
    maxWidth: 343,
    width: 'calc(100% - 48px - 12px - 110px)',
    [theme.breakpoints.down('sm')]: {
      width: 'calc(100% - 48px - 48px - 12px)',
    },
  },
  visible: {
    opacity: 1,
  },
  containerBottom: {
    position: 'relative',
    '&:last-child': {
      paddingBottom: 50,
    },
  },
  addButtonBottom: {
    position: 'absolute',
    bottom: 0,
  },
}));

const AddAnotherField = ({
  className,
  values,
  children,
  removeFunc,
  addFunc,
  isLast,
  addDisabled,
  addButtonText,
  addButtonPosition,
  inputClassName,
  withDelete,
  isDisabled,
}) => {
  const classes = useStyles();

  return (
    <div className={cn(className, classes.container, { [classes.containerBottom]: addButtonPosition === 'bottom' })}>
      <div className={cn(classes.input, inputClassName)}>{children}</div>
      <div className={classes.deleteButton}>
        {!isDisabled && (values.length > 1 || withDelete) && (
          <IconButton onClick={removeFunc} tabIndex={0}>
            <DeleteFbIcon />
          </IconButton>
        )}
      </div>
      <div
        className={cn(
          classes.addButton,
          { [classes.visible]: isLast },
          { [classes.addButtonBottom]: addButtonPosition === 'bottom' },
        )}
      >
        <AddAnotherFieldButton
          tabIndex={addDisabled ? -1 : 0}
          onClick={addFunc}
          disabled={addDisabled || !isLast}
          addButtonText={addButtonText}
        />
      </div>
    </div>
  );
};

AddAnotherField.propTypes = {
  className: PropTypes.string,
  inputClassName: PropTypes.string,
  values: PropTypes.array,
  children: PropTypes.node.isRequired,
  removeFunc: PropTypes.func.isRequired,
  addFunc: PropTypes.func.isRequired,
  isLast: PropTypes.bool.isRequired,
  addDisabled: PropTypes.bool,
  addButtonText: PropTypes.string,
  addButtonPosition: PropTypes.oneOf(['bottom', 'right']),
  withDelete: PropTypes.bool,
  isDisabled: PropTypes.bool,
};

AddAnotherField.defaultProps = {
  className: '',
  values: [],
  addButtonText: `${TP}.FN_ADD_ANOTHER_FIELD`,
  addDisabled: false,
  addButtonPosition: 'right',
  withDelete: false,
  isDisabled: false,
};

export default memo(AddAnotherField);
